import React from 'react';
import { Icon } from 'tea-component';
import classNames from 'classnames';
import './index.scss';

const Loading = (props: any) => {
  const { className, style } = props;
  const { text = ""} = props;
  return (
    <div className={classNames('db-loading', className)} style={style}>
      <Icon size="l" type="loading" className="loading-icon" />
      {text}
    </div>
  );
};

export default Loading;